import type { AlertProps } from 'react-bootstrap/Alert';
import AlertDefault from 'react-bootstrap/Alert';
import clsx from 'clsx';

export interface SizedAlertProps extends AlertProps {
  /** Optional size modifier */
  size?: 'sm' | 'md';
}

export const Alert = ({ size = 'md', className, children, ...rest }: SizedAlertProps) => {
  return (
    <AlertDefault {...rest} className={clsx(className, size === 'sm' && 'small p-2')}>
      {children}
    </AlertDefault>
  );
};
